module.exports = __webpack_public_path__ + "static/img/banner.c0b73389.png";